import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { getToken, storeToken, storeUserInfo } from '../../storage/LocalStorageService'
import { useDispatch } from 'react-redux'
import { setUserToken } from '../../storage/features/authSlice'
import { Loading } from '../../components/Loading'
import { useTranslation } from 'react-i18next'
import usePopupMsg from '../../hooks/usePopupMsg'

export default function GoogleCallback() {
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {t} = useTranslation('auth')
  const translation = t('google_auth')

  useEffect(() => {
    const fetchTokens = async () => {
      try {
        const params = new URLSearchParams(window.location.search)
        const code = params.get('code')
        const state = params.get('state')
        const googleError = params.get('error')

        if (googleError) {
          usePopupMsg.getState().open("fail to login.", "error");
          throw new Error(googleError)
        }

        if (!code || !state) {
          usePopupMsg.getState().open("fail to login.", "error");
          throw new Error(`${translation.missing_code}`) 
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/user/google-login/`,
          { params: { code, state, error:googleError } }
        )
        const { token, user } = response.data
        storeToken(token)
        storeUserInfo(user)

        const { access_token } = getToken() || {}
        if (access_token) {
          dispatch(setUserToken({ access_token }))
        }

        navigate('/')
        usePopupMsg.getState().open("login successfully.", "success");
      } catch (err) {
        setError(err.response?.data?.error || err.message || 'Unknown error')
        usePopupMsg.getState().open("fail to login.", "error");

      } finally {
        setIsLoading(false)
      }
    }

    fetchTokens()
  }, [dispatch, navigate, translation.missing_code])

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loading />
      </div>
    )
  }

  if (error) {
    return (
      <div className="max-w-md mx-auto mt-20 p-6 bg-red-50 border border-red-200 rounded-lg">
        <h1 className="text-2xl font-semibold text-red-700 mb-4 dark:bg-white">{translation.login_error}</h1>
        <p className="az-error-message">{error}</p>
      </div>
    )
  }

  return null
}
